import script from "./Admin-User-List.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin-User-List.vue?vue&type=script&setup=true&lang=js"

import "./Admin-User-List.vue?vue&type=style&index=0&id=8e7dd03e&lang=css"

const __exports__ = script;

export default __exports__